import React from 'react';
import { useField } from 'formik';
import { TextField } from '@mui/material';

const MyTextInput = ({ label, disabled = false, autoComplete = 'off', ...props }) => {

    const [field, meta] = useField(props);

    return (

        <TextField
            sx={{ width: '100%' }}
            variant='outlined'
            autoComplete={ autoComplete }
            label={label}
            { ...field }
            { ...props }
            error={ meta.touched && Boolean(meta.error) }
            helperText={ meta.touched && meta.error }
        />

    )

}

export default MyTextInput